import axios from 'axios';
import Vue from 'vue';
import VueAxios from 'vue-axios';
import Vuex from 'vuex';

import {article} from '@/articles/store';
import {booking} from '@/bookings/store';
import {feedback} from '@/feedback/store';
import {menu} from '@/menu/store';
import {site} from '@/site/store';

import {user} from './store/index';

Vue.use(Vuex);
Vue.use(VueAxios, axios);

// Export store
export const store = new Vuex.Store({
  modules: {
    user,
    site,
    menu,
    article,
    feedback,
    booking,
  },
});
